module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "f20 bold"
  }, [_vm._v(_vm._s(_vm.theme.name))])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t编号：" + _vm._s(_vm.theme.id) + "\n\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t名称：" + _vm._s(_vm.theme.name) + "\n\t\t")]), _vm._v(" "), _c('div', {}, [_vm._v("\n\t\t\t描述：" + _vm._s(_vm.theme.description) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "italic"
  }, [_vm._v("\n\t\t\t以下为预览效果\n\t\t")])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-50cc3406"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/theme/widget/DetailFrame.vue
// module id = 980
// module chunks = 1